import React, { FC } from "react";
import classNames from "classnames";
import {
  XCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/solid";
import { notification } from "../../../interfaces";

const Alerts: FC<notification.IAlerts> = ({
  title,
  errors,
  severity = notification.Severity.ERROR,
}) => {
  return (
    <div
      className={classNames({
        "rounded-md p-4": true,
        " bg-red-50": severity === notification.Severity.ERROR,
        " bg-blue-50": severity === notification.Severity.INFO,
        " bg-yellow-50": severity === notification.Severity.WARNING,
        " bg-green-50": severity === notification.Severity.SUCCESS,
      })}
    >
      <div className="flex">
        <div className="flex-shrink-0">
          {severity === notification.Severity.ERROR && (
            <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
          )}
          {severity === notification.Severity.INFO && (
            <InformationCircleIcon
              className="h-5 w-5 text-blue-400"
              aria-hidden="true"
            />
          )}
          {severity === notification.Severity.WARNING && (
            <ExclamationTriangleIcon
              className="h-5 w-5 text-yellow-400"
              aria-hidden="true"
            />
          )}
          {severity === notification.Severity.SUCCESS && (
            <CheckCircleIcon
              className="h-5 w-5 text-green-400"
              aria-hidden="true"
            />
          )}
        </div>
        <div className="ml-3">
          <h3
            className={classNames({
              "text-sm font-medium": true,
              " text-red-800": severity === notification.Severity.ERROR,
              " text-blue-800": severity === notification.Severity.INFO,
              " text-yellow-800": severity === notification.Severity.WARNING,
              " text-green-800": severity === notification.Severity.SUCCESS,
            })}
          >
            {title}
          </h3>
          {errors?.length > 0 && (
            <div
              className={classNames({
                "mt-2 text-s": true,
                " text-red-700": severity === notification.Severity.ERROR,
                " text-blue-700": severity === notification.Severity.INFO,
                " text-yellow-700": severity === notification.Severity.WARNING,
                " text-green-700": severity === notification.Severity.SUCCESS,
              })}
            >
              <ul role="list" className="list-disc pl-5 space-y-1">
                {errors.map((e) => (
                  <li key={e.label}>{e.label}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { Alerts };
